import React from 'react';
import { Heading, Text } from './ui';
import '../styles/Login.css';

/**
 * Shown by `PrivateRoute` when the read that decides access never reached the
 * server, even after retrying: whether this account may come in is unknown,
 * so it says that and offers to try again, rather than sending a signed-in
 * customer to the waitlist. Laid out like the waitlist page it replaces.
 */
export default function AccessCheckUnreachable({ onRetry }) {
  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo-container">
          <img src="/FullLogo.png" alt="Housfully" className="logo" />
        </div>
        <Heading level={1} tone="dark" className="preview-title">
          We couldn't reach Housfully
        </Heading>
        <Text tone="dark" className="subtitle">
          Check your connection, then try again.
        </Text>
        <button type="button" className="waitlist-button" onClick={onRetry}>
          Try again
        </button>
      </div>
    </div>
  );
}
